import api from './api';

const paymentMethodService = {
  // Récupérer tous les modes de paiement
  getAll: async () => {
    const response = await api.get('/api/payment-methods');
    return response.data;
  },

  // Récupérer uniquement les modes actifs
  getActive: async () => {
    const response = await api.get('/api/payment-methods/active');
    return response.data;
  },

  // Récupérer un mode de paiement spécifique
  getById: async (id) => {
    const response = await api.get(`/api/payment-methods/${id}`);
    return response.data;
  },

  // Créer un nouveau mode de paiement
  create: async (data) => {
    const response = await api.post('/api/payment-methods', data);
    return response.data;
  },

  // Mettre à jour un mode de paiement
  update: async (id, data) => {
    const response = await api.put(`/api/payment-methods/${id}`, data);
    return response.data;
  },

  // Supprimer un mode de paiement
  delete: async (id) => {
    const response = await api.delete(`/api/payment-methods/${id}`);
    return response.data;
  },

  // Activer/Désactiver un mode de paiement
  toggleActive: async (id) => {
    const response = await api.patch(`/api/payment-methods/${id}/toggle`);
    return response.data;
  },

  // Mettre à jour l'ordre d'affichage
  updateOrder: async (orders) => {
    const response = await api.post('/api/payment-methods/update-order', { orders });
    return response.data;
  },
};

export default paymentMethodService;

